module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/EndOfEmpire_Key-Art.dbc974f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/EndOfEmpire_Key-Art.jpg
// module id = GOap
// module chunks = 0